import { render, staticRenderFns } from "./RelativeSimple.vue?vue&type=template&id=437a0380"
import script from "./RelativeSimple.vue?vue&type=script&lang=js"
export * from "./RelativeSimple.vue?vue&type=script&lang=js"
import style0 from "./RelativeSimple.vue?vue&type=style&index=0&id=437a0380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports